/* eslint-disable promise/param-names */
const state = {
  filters:{
      plant: '',
      plant_name: '',
      year: '',
      period: '',
      area: '',
      sector: '',
      machine: '',
      component: '',
      technique: ''
  },
}

const getters = {
  filters: state => state.filters,
}

const mutations = {
    changeFilters(state, payload){
        let key = null;
        for (key in payload) {
          localStorage.setItem(key, payload[key])
        }
        state.filters = payload;
    }
}

export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/filters.js